module.exports = __webpack_public_path__ + "img/qrcode.79359705.png";